import {EditorSelection} from "@codemirror/state";
import {isSingleCursor} from "../state.js";

export function leaveKeyboard({state, dispatch}) {
  if (isSingleCursor(state)) {
    const keyboard = state.tree.topNode.resolve(state.selection.main.from, 1);
    if (keyboard.name === 'Keyboard' || keyboard.name === 'KeyboardKey') {
      dispatch({selection: EditorSelection.single(keyboard.to)});
      return true;
    }
  }
  return false;
}
